import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Observable";
import {map} from "rxjs/operators";
import {ConfigProvider} from "../base/config";

/*
  Generated class for the PrestadorServicoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrestadorServicoProvider {

  public ressourceUrl: any = ConfigProvider.host + '/api/v1/front/saude/prestadorservico';

  constructor(public http: HttpClient) {

  }

  list(convenio = null, params: any = {}, headers: HttpHeaders = null): Observable<any> {
    return this.http.get(this.ressourceUrl, {
      params: params,
      headers: headers
    }).pipe(
        map((response: any) => {
          return response;
        })
    );
  }

  nextPage(_url: string = ""): Observable<any> {

    let options = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Enctype': 'application/json'
      }
    };

    return this.http.get(_url, options);
  }

}



// WEBPACK FOOTER //
// ./src/providers/prestador-servico/prestador-servico.ts